import Vue from 'vue';
import linkDynamic from '@editor/droplets/_bubble-options/components/link-dynamic';

export default Vue.component('edit-blog-post', {
  template: require('./template.html'),
  name: 'edit-blog-post',
  props: ['droplet', 'show-edit-bubble', 'profile', 'dynamic-item'],
  components: {
    linkDynamic,
  },
  data() {
    return {
      display: {
        showImage: false,
      },
    };
  },
  watch: {
    showEditBubble(open) {
      if (open) {
        this.setInitialValies();
      }
    },
  },
  methods: {
    setInitialValies() {
      this.display.showImage = this.droplet.showImage;
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/blog-post/components/_edit-options/index.js